import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { LoggingService } from '../logging-service/logging.service';
import { AppConfigService } from '../app-config-service/app-config.service';
////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     12/11/2017
// Description: Service to update header and footer from different child components
////-------------------------------------------------------------------------------------------
@Injectable()
export class ShellUpdateService {

  // Subscribe to this to get message updates for the shell
  public ShellMessage: Subject<ShellUpdateMessage>;
  public ShellAction: Subject<ShellActionMessage>;

  constructor(private loggingService: LoggingService, private appConfigService: AppConfigService) {
    this.ShellMessage = new Subject<ShellUpdateMessage>();
    this.ShellAction = new Subject<ShellActionMessage>();
  }

  // Updates the shell with a given message
  public sendShellUpdateMessage(message: ShellUpdateMessage) {
    this.loggingService.log("Sending shell update message", this.appConfigService.LogToConsole);
    if (message == undefined)
      throw "ShellUpdateMessage cannot be undefined";

    if (message == null)
      throw "Message cannot be null";

    // We have a valid message.
    this.ShellMessage.next(message);
  }

  // Sends a shell action (for example, closing a menu. to any subscribers.)
  public sendShellUpdateActionMessage(action: ShellActionMessage) {
    this.loggingService.log("Sending shell action update message", this.appConfigService.LogToConsole);
    if (action == undefined)
      throw "ShellAction cannot be undefined";

    if (action == null)
      throw "ShellAction cannot be null";

    this.ShellAction.next(action);
  }
}

// For sending UI update messages (text for header and footers)
export class ShellUpdateMessage {
  public Name: string = '';
  public Title: string = '';
  public Footer: string = '';
  public Copyright: string = '';
  public DisplayFooter: string = '';

  constructor(name: string, title: string, footer: string, copyright: string) {
    if (name != null)
      this.Name = name;

    if (title != null)
      this.Title = title;

    if (footer != null)
      this.Footer = footer;

    if (copyright != null)
      this.Copyright = copyright;
  }
}

// For sending UI update actions (closing menus for example)
export class ShellActionMessage {

  public OpenSideMenu;
  public DisplayFooter;
  public DisplayMenu;
  public DisplayBack;
  public DisplayHeader;

  constructor(openSideMenu: boolean, displayFooter: boolean, displayMenu: boolean, displayBack: boolean, displayheader: boolean) {

    if (displayFooter != null)
      this.DisplayFooter = displayFooter;

    if (openSideMenu != null)
      this.OpenSideMenu = openSideMenu;

    if (displayMenu != null)
      this.DisplayMenu = displayMenu;

    if (displayBack != null)
      this.DisplayBack = displayBack;

    if (displayheader != null)
      this.DisplayHeader = displayheader;

  }

}


// WEBPACK FOOTER //
// ./src/app/services/shell-update-service/shell-update.service.ts